<template>
 <Row>
        <i-col span="12">
    <Form ref="formValidate" :model="formValidate" :rules="ruleValidate" :label-width="100">
         <FormItem label="用户名" prop="username">
            <i-input v-model="formValidate.username" placeholder="请输入用户名"></i-input>
        </FormItem>
        <FormItem label="真实姓名" prop="realname">
            <i-input v-model="formValidate.realname" placeholder="请输入真实姓名"></i-input>
        </FormItem>
        <FormItem label="电子邮箱" prop="email">
            <i-input v-model="formValidate.email" placeholder="请输入电子邮箱"></i-input>
        </FormItem>
         <FormItem label="手机号码" prop="mobile">
            <i-input v-model="formValidate.mobile" placeholder="请输入手机号码"></i-input>
        </FormItem>
         <FormItem label="密码" prop="password">
                <i-input type="password" v-model="formValidate.password"></i-input>
            </FormItem>
            <FormItem label="重复密码" prop="passwdCheck" v-if="passwdCheck()">
                <i-input type="password" v-model="formValidate.passwdCheck"></i-input>
            </FormItem>
        <FormItem label="角色" prop="role">
              <Select v-model="formValidate.role"  multiple style="width:260px">
                <Option v-for="item in roleList" :value="item.id" :key="item.id">{{ item.name }}</Option>
             </Select>
        </FormItem>
        <FormItem label="超级管理员" prop="issupper">
            <RadioGroup v-model="formValidate.issupper">
                <Radio label="1">是</Radio>
                <Radio label="0">不是</Radio>
            </RadioGroup>
        </FormItem>  
        <FormItem label="锁定状态" prop="islock">
            <RadioGroup v-model="formValidate.islock">
                <Radio label="1">锁定</Radio>
                <Radio label="0">未锁定</Radio>
            </RadioGroup>
        </FormItem>  
        <FormItem>
            <Button type="primary" @click="handleSubmit('formValidate')" v-if="privilegesbtn('/admin/create')">提交</Button>
            <!-- <Button type="ghost" @click="handleReset('formValidate')" style="margin-left: 8px">Reset</Button> -->
        </FormItem>
    </Form>
     </i-col>
        <i-col span="12"></i-col>
    </Row>
  
</template>
<script>
import { mapState } from "vuex";
import { usernameadmin, createadmin } from "../../api/adminapi";
import privilegesbtn from "../../constant/privilegesbtn.js";
export default {
  data() {
    const validatePass = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("请输入密码"));
      } else {
        if (this.formValidate.passwdCheck !== "") {
          // 对第二个密码框单独验证
          this.$refs.formValidate.validateField("passwdCheck");
        }
        callback();
      }
    };
    const validatePassCheck = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("请再次输入密码"));
      } else if (value !== this.formValidate.password) {
        callback(new Error("两次密码不同"));
      } else {
        callback();
      }
    };
    const validateusername = (rule, value, callback) => {
      let para = {
        username: value
      };
      usernameadmin(para).then(res => {
        let data = res.data;
        if (data.code == 1) {
          callback();
        } else {
          callback(new Error(data.message));
        }
      });
    };
    const validatemobile = (rule, value, callback) => {
      var reg = /^1([358][0-9]|4[579]|66|7[0135678]|9[89])[0-9]{8}$/;
      //  /^[1][3|7|8|6|5]{2}[0-9]{8}$/;
      if (reg.test(value)) {
        callback();
      } else {
        callback(new Error("手机格式错误"));
      }
    };
    return {
      formValidate: {
        username: "",
        realname: "",
        email: "",
        mobile: "",
        role: [],
        issupper: "0",
        islock: "0",
        password: "",
        passwdCheck: ""
      },
      labelInValue: true,
      ruleValidate: {
        username: [
          { required: true, message: "请输入用户名", trigger: "blur" },
          { validator: validateusername, trigger: "blur" }
        ],
        realname: [
          { required: true, message: "请输入真实姓名", trigger: "blur" }
        ],
        email: [
          { required: true, message: "请输入电子邮箱", trigger: "blur" },
          { type: "email", message: "邮箱格式错误", trigger: "blur" }
        ],
        mobile: [
          { required: true, message: "请输入手机号", trigger: "blur" },
          { validator: validatemobile, trigger: "blur" }
        ],
        password: [{ validator: validatePass, trigger: "blur" }],
        passwdCheck: [{ validator: validatePassCheck, trigger: "blur" }]
      }
    };
  },
  computed: mapState({
    // 箭头函数可使代码更简练
    roleList: state => state.roleList
  }),
  methods: {
    privilegesbtn: privilegesbtn,
    handleSubmit(name) {
      this.$refs[name].validate(valid => {
        if (valid) {
          this.addadmin();
        } else {
          this.$Message.error("Fail!");
        }
      });
    },
    handleReset(name) {
      this.$refs[name].resetFields();
    },
    addadmin() {
      let para ={
           username: "",
        realname: "",
        email: "",
        mobile: "",
        role: [],
        issupper: "0",
        islock: "0",
        password: "",
        passwdCheck: ""
      } ;
      this.$Loading.start();
      createadmin(para).then(res => {
        this.$Loading.finish();
        let data = res.data;
        if (data.code == 1) {
          this.$Message.success(data.message);
          this.init();
        } else {
          this.formValidate.password='';
          this.formValidate.passwdCheck=''
          self.$Message.error(data.message);
        }
      });
    },
    init() {
      this.formValidate = {
        username: "",
        realname: "",
        email: "",
        mobile: "",
        role: [],
        issupper: "0",
        islock: "0",
        password: "",
        passwdCheck: ""
      };
    },
    passwdCheck() {
      if (this.formValidate.password != "") {
        return true;
      } else {
        return false;
      }
    },
    setparams(params) {}
  },
  mounted() {}
};
</script>



// WEBPACK FOOTER //
// src/pages/admin/add.vue